import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * External dependencies
 */
import { useContext } from 'react';
import { store, TOGGLE_MAP_VIEW } from '../state/state';
/**
 * Internal dependencies
 */
import Button from './Button';
import Icon from './Icon';
const MapToggle = () => {
    const globalState = useContext(store);
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const { state, dispatch } = globalState;
    const toggleMap = () => {
        dispatch({
            type: TOGGLE_MAP_VIEW,
            showMap: !state.showMap
        });
    };
    return (_jsxs("section", { className: "flex items-center", children: [_jsx(Button, { onClick: toggleMap, invert: state.showMap, variant: "secondary", height: "!h-10", children: _jsxs("span", { className: "flex items-center", children: [_jsx("span", { className: "hidden tablet-landscape:mr-2 tablet-landscape:block", children: "Grid" }), _jsx("span", { className: "w-4 h-4", children: _jsx(Icon, { name: "grid" }) })] }) }), _jsx(Button, { onClick: toggleMap, invert: state.showMap, variant: "grey", height: "!h-10", children: _jsxs("span", { className: "flex items-center", children: [_jsx("span", { className: "hidden tablet-landscape:mr-2 tablet-landscape:block", children: "Map" }), _jsx("span", { className: "w-4 h-4", children: _jsx(Icon, { name: "map" }) })] }) })] }));
};
export default MapToggle;
